module.exports = __webpack_public_path__ + "media/images/msec_4-2-4356b5c9ebf30de825fa8e7ffcd29c3a.png";